export const ACTIVATE_CAMERA_SIM_CARD_OPEN_MODAL  = "ACTIVATE_CAMERA_SIM_CARD_OPEN_MODAL";
export const ACTIVATE_CAMERA_SIM_CARD_CLOSE_MODAL  = "ACTIVATE_CAMERA_SIM_CARD_CLOSE_MODAL";

export const ACTIVATE_CAMERA_SIM_CARD_REQUEST  = "ACTIVATE_CAMERA_SIM_CARD_REQUEST";
export const ACTIVATE_CAMERA_SIM_CARD_RESULT  = "ACTIVATE_CAMERA_SIM_CARD_RESULT";

export const ACTIVATE_CAMERA_SIM_CARD_UPDATE_DEVICES  = "ACTIVATE_CAMERA_SIM_CARD_UPDATE_DEVICES";

